import React from 'react'
import Select from 'react-select'

const DropdownFilter = props => {
  const options = [
    { label: 'All', value: 'All' },
    { label: 'Published', value: 'Published' },
    { label: 'On hold', value: 'On hold' },
    { label: 'Sold', value: 'Sold' },
    { label: 'Auto sold', value: 'Auto marked as sold' },
    { label: 'Action required', value: 'Action required' },
    { label: 'Disapproved', value: 'Disapproved' },
    { label: 'Awaiting approval', value: 'Awaiting approval' },
    { label: 'Draft', value: 'Draft' },
    { label: 'Interest from buyers', value: 'Interest from buyers' }
  ]

  const defaultValue = options.filter(option => option.value === props.value)[0]

  const customStyles = {
    container: (base) => ({
      ...base,
      minWidth: '200px'
    }),
    control: (base, state) => ({
      ...base,
      boxShadow: state.isFocused ? 0 : 0,
      borderColor: '#AAAAAA',
      ':hover': {
        borderColor: '#AAAAAA'
      }
    }),
    menu: (base) => ({
      ...base,
      minWidth: '200px'
    }),
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? 'lightgray' : 'white',
        color: isSelected ? 'black' : 'inherit',
        ':active': {
          backgroundColor: 'lightgray',
          color: 'black'
        },
        ':hover': {
          backgroundColor: '#F3F3F3',
          color: 'black'
        }
      }
    }
  }

  return (
    <Select
      options={options}
      onChange={props.onChange}
      value={props.selected}
      defaultValue={defaultValue}
      styles={customStyles}
    />
  )
}

export default DropdownFilter
